<script setup lang="ts">
import { Button, Drawer, Typography } from '@apexx/component-library';

defineProps<{
	open: boolean;
	currentDisplayVersion?: string;
	availableDisplayVersion?: string;
}>();

const emit = defineEmits<{
	'update:open': [open: boolean];
	update: [];
	dismiss: [];
}>();
</script>

<template>
	<Drawer
		:open="open"
		placement="bottom"
		title="Update available"
		sub-title="A newer version of the app is available."
		height="auto"
		@update:open="emit('update:open', $event)"
	>
		<div class="flex flex-col gap-4 px-1 py-2">
			<div class="flex items-center justify-between rounded-xl bg-surface-elevated px-4 py-3">
				<Typography variant="body" class="text-on-surface-muted" as="span">
					Current version
				</Typography>
				<Typography variant="body" class="font-semibold text-on-surface" as="span">
					{{ currentDisplayVersion ?? '—' }}
				</Typography>
			</div>

			<div
				v-if="availableDisplayVersion"
				class="flex items-center justify-between rounded-xl bg-primary/10 px-4 py-3"
			>
				<Typography variant="body" class="text-primary" as="span">
					Available version
				</Typography>
				<Typography variant="body" class="font-semibold text-primary" as="span">
					{{ availableDisplayVersion }}
				</Typography>
			</div>

			<Typography variant="body" class="text-on-surface-muted" as="p">
				Update now to get the latest improvements and fixes.
			</Typography>
		</div>

		<template #footer>
			<div class="flex w-full gap-3">
				<Button variant="outline" class="flex-1" @click="emit('dismiss')">Later</Button>
				<Button class="flex-1" @click="emit('update')">Update now</Button>
			</div>
		</template>
	</Drawer>
</template>
